// extracted by mini-css-extract-plugin
export default {"restriction":"restriction_restriction__M1NZS"};